import { render, staticRenderFns } from "./Overseas.vue?vue&type=template&id=7e933b5e&scoped=true&"
import script from "./Overseas.vue?vue&type=script&lang=js&"
export * from "./Overseas.vue?vue&type=script&lang=js&"
import style0 from "./Overseas.vue?vue&type=style&index=0&id=7e933b5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e933b5e",
  null
  
)

export default component.exports